(() => {
  const selector = '[data-eg-start-with-gallery-hero="true"]';
  const wakeEvents = ['pointerdown', 'keydown', 'click', 'change'];

  function install(root) {
    if (root.dataset.egGalleryHeroGuardInstalled === 'true') return true;
    const sections = window.Shopify?.theme?.sections?.instances || [];
    const section = sections.find((entry) => entry?.product?.container === root);
    const product = section?.product;
    if (!product || typeof product.onOptionChange !== 'function') return false;

    const heroId = String(root.dataset.initialMediaId || '');
    if (!heroId) return false;
    const original = product.onOptionChange;

    function restoreHero() {
      if (product.mobileSwiper && !product.mobileSwiper.destroyed) {
        const slide = product.mobileSwiper.el?.querySelector(`[data-media-item-id="${heroId}"]`);
        if (slide?.parentElement) {
          const index = [...slide.parentElement.children].indexOf(slide);
          product.mobileSwiper.slideTo(index, 0);
        }
      }
      if (typeof product._switchCurrentImage === 'function') {
        product._switchCurrentImage(heroId);
      }
    }

    product.onOptionChange = function(event) {
      const result = original.call(this, event);
      requestAnimationFrame(() => requestAnimationFrame(restoreHero));
      return result;
    };
    root.dataset.egGalleryHeroGuardInstalled = 'true';
    return true;
  }

  function arm(root) {
    if (install(root) || root.dataset.egGalleryHeroGuardArmed === 'true') return;
    root.dataset.egGalleryHeroGuardArmed = 'true';

    const wake = () => {
      if (!install(root)) return;
      wakeEvents.forEach((name) => root.removeEventListener(name, wake, true));
      delete root.dataset.egGalleryHeroGuardArmed;
    };
    wakeEvents.forEach((name) => root.addEventListener(name, wake, true));

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (install(root)) {
        clearInterval(timer);
        wakeEvents.forEach((name) => root.removeEventListener(name, wake, true));
        delete root.dataset.egGalleryHeroGuardArmed;
      } else if (attempts >= 40) {
        clearInterval(timer);
      }
    }, 100);
  }

  function installAll() {
    document.querySelectorAll(selector).forEach(arm);
  }

  installAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installAll, { once: true });
  }
  document.addEventListener('shopify:section:load', installAll);
})();
